module.exports = {"data":{"site":{"siteMetadata":{"title":"Paul Conrad Architects","description":"","keywords":"","url":"https://www.conradarchitects.com"}},"wordpressOptions":{"meta_description_default":"Paul Conrad Architects believes in the power of architecture and interior design to enhance our lives and the cities in which we live."}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 176
// module chunks = 60335399758886 114276838955818